import { useEffect, useState } from 'react';

// The season's characters (a Map of id to Character), or null while they
// load. Games only carry character ids; the portraits show once these are in
// the cache, so a component that draws them calls this to render again when
// they arrive. Takes a null match (nothing to load).
export default function useSeasonCharacters(match) {
	const season = match?.season;
	const [characters, setCharacters] = useState(() => season?.characters || null);
	useEffect(() => {
		let active = true;
		const loading = season?.getCharacters?.();
		if(loading) {
			loading.then((loaded) => active && setCharacters(loaded)).catch(() => {});
		}
		return () => {
			active = false;
		};
	}, [season]);
	return characters;
}
